import React, { useState } from 'react';
import PlanPromoPage from './PlanPromoPage';
import image from './assets/sales-img-online_lang.jpg';
import { push, Routes } from 'routing';
import { useTranslation } from 'services/localization';
import { availableLanguagesWithInfo } from 'common/utils/languageUtils';
import { getLanguageName } from 'common/locales/utils';
import { Box, Collapse, Link, Typography } from '@mui/material';

const LanguagePromoPage = () => {
	const { t } = useTranslation();
	const [showLanguages, setShowLanguages] = useState<boolean>(false);
	const languagesTranslated = availableLanguagesWithInfo
		.map((lang) => getLanguageName(lang.lang, t))
		.sort()
		.join(', ');

	const description = (
		<>
			<Typography variant="body1" sx={{ mb: 3 }}>
				{t(
					'promoPages.languages.description',
					'Get a multilingual store in 15+ different languages. Easily add translations for your own content.',
				)}
			</Typography>
			<Link variant="body1" onClick={() => setShowLanguages(!showLanguages)}>
				{t('promoPages.languages.showAvailableLanguages', 'Show available languages')}
			</Link>
			<Box mb={3}>
				<Collapse in={showLanguages}>
					<Typography variant="body1" sx={{ mb: 3 }}>
						{languagesTranslated}
					</Typography>
				</Collapse>
			</Box>
			<Typography variant="body1" sx={{ mb: 3 }}>
				{t('promoPages.languages.description2', 'Upgrade to Rentle Basic to start using Languages')}
			</Typography>
		</>
	);
	return (
		<PlanPromoPage
			tag={t('promoPages.languages.tag', 'Languages')}
			title={t('promoPages.languages.title', 'Get Rentle in your language')}
			description={description}
			image={image}
			primaryCta={{
				text: t('account.stores.upgradePlan', 'Upgrade plan'),
				onClick: () => push(Routes.PlanConfirm('BASIC'), { from: Routes.ACCOUNT_LANGUAGES }),
				requiredFeature: 'PLAN_BILLING',
			}}
			secondaryCta={{
				text: t('homeView.bookADemo', 'Book a demo'),
				onClick: () => window.open('https://www.rentle.io/demo', '_blank'),
			}}
		/>
	);
};

export default LanguagePromoPage;
